import type { TopicId } from "../types/dashboard";
import { TOPICS, type TopicConfig } from "./topics";

export const MOBILE_TOPIC_IDS: TopicId[] = ["dashboard", "ocpp", "frequency"];

export const MOBILE_TOPICS: TopicConfig[] = TOPICS.filter((t) =>
  MOBILE_TOPIC_IDS.includes(t.id),
);

export const DESKTOP_ONLY_TOPIC_IDS: TopicId[] = [
  "ecg",
  "power",
  "fcr",
  "infra",
  "admin",
  "devops",
];

export function isMobileTopic(id: TopicId): boolean {
  return MOBILE_TOPIC_IDS.includes(id);
}

export function pathToMobileTopic(pathname: string): TopicId {
  const match = MOBILE_TOPICS.find((t) => t.path === pathname);
  return match?.id ?? "dashboard";
}
